import React, { useState } from "react";
import { FiGift, FiCopy, FiCheck } from "react-icons/fi";
import toast from "react-hot-toast";

export const ReferralCard = ({ referralCount, referralLink }) => {
  const [copied, setCopied] = useState(false);
  const fullLink = `https://www.zamchainadvanceinvestment.com/register${referralLink}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(fullLink);
    setCopied(true);
    toast.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="p-5 rounded-[24px] bg-[#cbd2f6] shadow-sm flex flex-col justify-between min-h-[160px] transition-all duration-300 hover:-translate-y-1 hover:shadow-md border border-indigo-100/50">
      {/* Top Section: Title and Icon */}
      <div className="flex justify-between items-start">
        <div className="flex flex-col">
          <span className="text-[13px] font-bold text-gray-700 leading-tight">
            Referral <br /> Bonus
          </span>
        </div>
        <div className="text-[#4c5ec0] opacity-90 p-2 bg-white/30 rounded-lg">
          <FiGift size={20} />
        </div>
      </div>

      {/* Middle Section: Value and Sparkline */}
      <div className="mt-2">
        <div className="text-2xl font-extrabold text-gray-900 tracking-tight">
          {referralCount || 0}
        </div>
        <div className="text-[10px] font-medium text-[#4c5ec0]/80 uppercase tracking-wider">
          Total Referrals
        </div>
      </div>

      {/* Bottom Section: Action Button */}
      <button
        onClick={handleCopy}
        className="mt-4 w-full bg-white hover:bg-gray-50 text-gray-700 py-2 rounded-xl text-[12px] font-bold shadow-sm flex items-center justify-center gap-2 transition-all active:scale-95"
      >
        <span>{copied ? "Copied" : "Copy Link"}</span>
        {copied ? (
          <FiCheck size={14} className="text-green-500" />
        ) : (
          <FiCopy size={14} className="text-[#4c5ec0]" />
        )}
      </button>
    </div>
  );
};
